class MyWeeklyPicksExceptionController {
    constructor(shopperService) {
        this.shopperService = shopperService;
    }
}

const myWeeklyPicksExceptionComponentDefinition = {
    bindings: {
        category: '<',
    },
    controller: ['ShopperService', MyWeeklyPicksExceptionController],
    template: require('./my-weekly-picks-exception.component.html').trim(),
};

module.exports = {
    MyWeeklyPicksExceptionController,
    myWeeklyPicksExceptionComponentDefinition,
};



// WEBPACK FOOTER //
// ./src/shop/browse/my-weekly-picks-exception.component.js